<template>
  <DragDialog
    :title="getTitle()"
    :width="400"
    :visible.sync="visible"
    :footerBtn="['cancel', 'submit']"
    :submit="submit"
    :cancel="cancel"
    class="dialog-primary-light">
    <div class="tip-content-box">注：名称不少于1个字符，且不允许重复</div>
    <el-form
      @submit.native.prevent
      :model="form"
      class="form public-form-primary"
      label-width="60px"
      :rules="rules"
      ref="form">
      <el-form-item
        class="form-item"
        label="名称:"
        prop="name">
        <el-input
          class="input-primary"
          size="small"
          :maxlength="30"
          show-word-limit
          v-model="form.name"
          placeholder="请输入名称" />
      </el-form-item>
    </el-form>
  </DragDialog>
</template>

<script>
import DragDialog from '@/components/CustomDragDialog.vue'

import {
  createDataDictionaryService,
  updateDataDictionaryService
} from '@/service/dataDictionary'
export default {
  data() {
    const validDisplayNameRule = (rule, value, callback) => {
      if (value.length === value.trimStart().trimEnd().length) {
        return callback()
      } else {
        callback(new Error('开头和结尾不允许有空格'))
      }
    }
    return {
      form: {
        name: ''
      },
      rules: {
        name: [
          {
            required: true,
            message: '请输入名称',
            trigger: 'blur'
          },
          { validator: validDisplayNameRule }
        ]
      }
    }
  },
  props: {
    visible: Boolean,
    dataInfo: Object
  },
  components: {
    DragDialog
  },
  watch: {
    visible: function (newVal) {
      if (newVal) {
        if (this.dataInfo.id) {
          this.form.name = this.dataInfo.name
        }
      }
    }
  },
  methods: {
    async submit() {
      if (this.dataInfo.id) {
        let params = {
          id: this.dataInfo.id,
          name: this.form.name
        }
        let response = await updateDataDictionaryService(params)
        if (response.isSuccess) {
          this.$emit('refreshDictionaryList', true)
          this.$message.success('修改成功')
          this.cancel()
        } else {
          this.$message.error(response.errMsg)
        }
      } else {
        let params = {
          typeId: this.dataInfo.typeId,
          name: this.form.name
        }
        let response = await createDataDictionaryService(params)
        if (response.isSuccess) {
          this.$emit('refreshDictionaryList')
          this.$message.success('添加成功')
          this.cancel()
        } else {
          this.$message.error(response.errMsg)
        }
      }
    },
    cancel() {
      this.form = {
        name: ''
      }
      this.$emit('closeDialog')
    },
    getTitle() {
      return this.dataInfo?.id ? '编辑' : '新建'
    }
  }
}
</script>

<style lang="less" scoped>
.tip-content-box {
  padding-bottom: 6px;
  font-size: 12px;
  color: var(--page-tips-text-color);
  font-weight: 400;
  line-height: 20px;
  margin-left: 18px;
}

.el-form-item {
  margin-bottom: 0px;
}
</style>
